import moment, { Moment } from 'moment'

export const CALENDAR_DATE_QUERY = 'date'

export const formatCalendarDate = (date: Moment) => date.format('YYYY-MM-DD')

export const parseCalendarDateFromSearch = (search: string, orgTimezone: string, period: string): Moment => {
  const dateParam = new URLSearchParams(search).get(CALENDAR_DATE_QUERY)
  if (dateParam && moment(dateParam, 'YYYY-MM-DD', true).isValid()) {
    return moment.tz(dateParam, orgTimezone).startOf(period as moment.unitOfTime.StartOf)
  }

  return moment()
    .tz(orgTimezone)
    .startOf(period as moment.unitOfTime.StartOf)
}

export const buildCalendarSearch = (date: Moment) => `${CALENDAR_DATE_QUERY}=${formatCalendarDate(date)}`
